import type { FaireProductEntity } from "../../entity_types/product";

export const p_ythjreg8d4: FaireProductEntity = {
  token: "p_ythjreg8d4",
  type: "product",
  name: "Long Sleeve French Terry Lounge Set",
  brandToken: "b_4etrhoste6",
  brandName: "SKYLAR ROSE",
  imageUrl: "https://cdn.faire.com/fastly/7fcb383867aa8004a32e99558bd2af4fa82d3f42670eb11a191d8c6e715d2d0a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/056936f9a818fa42d01da5121a2c6705c57181d23d6fd586434018bf4dfb20a6.jpeg",
    "https://cdn.faire.com/fastly/e52e3d2ad684e80dd59dc3feaae3616bebccdb72a16514744019be76f281b18a.jpeg",
    "https://cdn.faire.com/fastly/6f86653fed1f7c4d49d6a4273d77c990292a01039e304de100ef7f30335b401f.jpeg",
    "https://cdn.faire.com/fastly/54c21554ae8d51279341c0bbd07e3d9f5e62c044d34344d6598e3acc1d825908.jpeg",
    "https://cdn.faire.com/fastly/0fbad43b2b1d1da1f5825eb79ffe8972a2d50754deef6e4ec1f8074298c0ed43.jpeg",
    "https://cdn.faire.com/fastly/139f9e81843623a1d7400878d25430f44b574d7ff28a73cc37c218a8525ab475.jpeg",
    "https://cdn.faire.com/fastly/5ace3d6be583f847557650dde452175ed3e51bf8803fa1e060551b22ab3795a0.jpeg",
    "https://cdn.faire.com/fastly/81cf212b480ea24b8673fa3c8f3b4db7a681dc72680d8634055c26e331130171.jpeg",
    "https://cdn.faire.com/fastly/ed81593c2ad86f30a9eb10d06407e6d9a4ca850db69205c55cdc76fa0952453f.jpeg"
  ],
  priceDollars: 27.75,
  description: "Long Sleeve French Terry LOUNGE SET, Crew Neck Wide Leg Comfy Fall Casual Essential, Great Basic for Layering a Cardigan or Sweater for Holiday Weather!",
  tags: [],
  msrpDollars: 69.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:28.714Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
